class ApplicationBinary {
  constructor (entryKey, base64Representation, changedBy, changeDate) {
    this.entryKey = entryKey
    this.base64Representation = base64Representation
    this.changedBy = changedBy
    this.changeDate = changeDate
  }
}

export default ApplicationBinary
